import { useEffect } from "react";
import { useSocket } from "@/hooks/useSocket";
import { trpc } from "@/lib/trpc";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export function NotificationListener() {
  const { user } = useAuth();
  const { onNotification, onConversationNew, onConversationUpdated, connected } = useSocket();
  const utils = trpc.useUtils();

  useEffect(() => {
    if (!connected || !user) return;

    // Écouter les nouvelles notifications (staff)
    const unsubNotif = onNotification((data: any) => {
      toast(data.title, {
        description: data.body,
        icon: "🔔",
        duration: 6000,
      });
    });

    // Écouter les nouvelles conversations créées par des clients
    const unsubConvNew = onConversationNew((data: any) => {
      toast("Nouvelle conversation", {
        description: `${data.subject}`,
        icon: "💬",
        duration: 5000,
      });

      // Rafraîchir les compteurs
      utils.messaging.getUnreadCount.invalidate();
      utils.messaging.listConversations.invalidate();
    });

    // Écouter les mises à jour de conversations (nouveaux messages)
    const unsubConvUpdate = onConversationUpdated((data: any) => {
      const isFromClient = data.lastMessage?.authorType === "CLIENT";
      if (isFromClient) {
        toast("Nouveau message client", {
          description: data.lastMessage?.content?.substring(0, 80) || "Un client a envoyé un message",
          icon: "💬",
          duration: 4000,
        });
      }

      // Rafraîchir les compteurs
      utils.messaging.getUnreadCount.invalidate();
      utils.messaging.listConversations.invalidate();
    });

    return () => {
      unsubNotif?.();
      unsubConvNew?.();
      unsubConvUpdate?.();
    };
  }, [connected, user, onNotification, onConversationNew, onConversationUpdated, utils]);

  return null;
}
